import Radium from "radium";
import InfoIcon from "material-ui/svg-icons/action/info";

const BASE_STYLE = {
  display: "table", // not full width
  backgroundColor: "#eaeaea",
  color: "#000",
  padding: "5px 10px",
  borderRadius: 10
};

const VERTICAL_BASE_STYLE = {
  display: "flex",
  alignItems: "center"
};

const ICON_STYLE = {
  verticalAlign: -6,
  color: "#0187d0",
  height: 20,
  width: 20,
  minWidth: 20,
  marginRight: 5
};

const InfoNotice = ({ children, style, verticalCenterIcon, ...rest }) => {
  return (
    <span
      style={[BASE_STYLE, verticalCenterIcon && VERTICAL_BASE_STYLE, style]}
      {...rest}
    >
      <InfoIcon
        style={Object.assign(
          {},
          ICON_STYLE,
          verticalCenterIcon && { marginRight: 8 }
        )}
      />
      {verticalCenterIcon ? <div>{children}</div> : children}
    </span>
  );
};

export default Radium(InfoNotice);



// WEBPACK FOOTER //
// ./src/app/components/partials/info-notice.jsx